@if (mobile()) {
    <button
        qpxButton
        matIconButton
        size="sm"
        context="secondary"
        tone="muted"
        [attr.aria-label]="`Show ${ariaLabel()} controls`"
        aria-haspopup="dialog"
        [attr.aria-expanded]="zoomPopover() !== null"
        [disabled]="disabled()"
        (click)="openZoomPopover($event)"
    >
        <ng-icon qpx name="lucideZoomIn" />
    </button>
} @else {
    <ng-container [ngTemplateOutlet]="zoomContents" />
}
<ng-template #zoomContents>
    <button
        #zoomOutButton
        qpxButton
        matIconButton
        [size]="mobile() ? 'sm' : 'md'"
        context="secondary"
        tone="muted"
        aria-label="Zoom out"
        qpxTooltip="Zoom out"
        [disabled]="disabled()"
        matTooltipPosition="below"
        (click)="zoomOut.emit()"
    >
        <ng-icon qpx name="lucideZoomOut" />
    </button>
    @if (mobile()) {
        <button
            qpxButton
            matIconButton
            size="sm"
            context="secondary"
            tone="muted"
            aria-label="Fit"
            qpxTooltip="Fit"
            [attr.aria-pressed]="zoom() === 'page-fit'"
            [disabled]="disabled()"
            (click)="zoomSelect.emit('page-fit')"
        >
            <ng-icon qpx name="lucideScan" />
        </button>
    } @else {
        <div class="relative">
            <input
                class="zoom-input"
                [class.active]="zoomMenuOpen()"
                type="text"
                role="combobox"
                [attr.aria-label]="ariaLabel()"
                [attr.aria-controls]="optionsId()"
                aria-autocomplete="list"
                [attr.aria-expanded]="zoomMenuOpen()"
                [attr.aria-activedescendant]="activeOptionId()"
                [disabled]="disabled()"
                [value]="zoomInputValue()"
                (focus)="onZoomFocus()"
                (click)="onZoomFocus()"
                (input)="onZoomInput($event)"
                (keydown)="onZoomKeydown($event)"
                (blur)="onZoomBlur()"
            />
            @if (zoomMenuOpen()) {
                <div
                    [id]="optionsId()"
                    class="zoom-options"
                    role="listbox"
                    [attr.aria-label]="`${ariaLabel()} options`"
                >
                    @for (option of filteredZoomOptions(); track option.label) {
                        <button
                            [id]="optionId($index)"
                            qpxButton="unstyled"
                            role="option"
                            class="zoom-option text-button"
                            tabindex="-1"
                            [class.active]="$index === activeOptionIndex()"
                            [attr.aria-selected]="
                                zoomDisplay() === option.label
                            "
                            (mousedown)="$event.preventDefault()"
                            (mouseenter)="activateOption($index)"
                            (click)="selectZoomOption(option)"
                        >
                            {{ option.label }}
                        </button>
                    }
                </div>
            }
        </div>
    }
    <button
        qpxButton
        matIconButton
        [size]="mobile() ? 'sm' : 'md'"
        context="secondary"
        tone="muted"
        aria-label="Zoom in"
        qpxTooltip="Zoom in"
        [disabled]="disabled()"
        matTooltipPosition="below"
        (click)="zoomIn.emit()"
    >
        <ng-icon qpx name="lucideZoomIn" />
    </button>
</ng-template>
